<template>
	<ThemeConfiguration css-layer="theme-config" />
	<NuxtLayout name="site-structure">
		<SiteHeader site-name="MBA" />

		<main
			id="main"
			class="bg-site-background min-h-[500px]"
			data-drag-context
		>
			<div class="notification__wrapper">
				<div class="notification">
					<a href="https://mba.malermestre.dk/om-mba/nyheder/betalingsloesning-for-mba/">
						<div>I løbet af maj måned 2025 vil det kræve abonnement at tilgå MBA</div>
						<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 46.001 85.999" enable-background="new 0 0 46.001 85.999" aria-hidden="true" focusable="false" class="w-[13px] h-[13px] fill-text"><path d="M1.004 80.094c-1.338 1.35-1.338 3.54 0 4.893 1.337 1.35 3.506 1.352 4.845 0l39.148-39.54c1.338-1.35 1.338-3.542 0-4.894L5.848 1.013c-1.338-1.35-3.505-1.35-4.844 0-1.338 1.353-1.338 3.542 0 4.894L36.706 43 1.004 80.094z"></path></svg>
					</a>
				</div>
			</div>

			<NuxtPage />
		</main>

		<SiteFooter class="mt-auto" />
	</NuxtLayout>
</template>

<script setup>
import '~/assets/css/index.css';
import { useMainStore } from '~/store/main';
const route = useRoute();

// Get state and set in store
const updateLogin = async () => {
	return await $fetch('/api/login/isloggedin', {
		method: 'GET',
		headers: useRequestHeaders(['cookie']),
	})
		.then((response) => {
			useMainStore().setLoggedIn(!(response?.isLoggedOut ?? true), response);
		})
		.catch((error) => {
			console.log(error);
			useMainStore().setLoggedIn(false);
		});
};
await updateLogin();

// Fetch site data
if (process.server) {
	const { $umbracoClient } = useNuxtApp();
	let data = await $umbracoClient.fetchData({
		params: {
			...route.query,
			cache: false,
			parts: ['site'],
		},
		route: route.fullPath,
	});

	if (data.site) {
		const main = useMainStore();
		main.setSiteData(data.site);
	}
}
</script>

<style>
	.notification__wrapper {
		display: flex;
		justify-content: center;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
	}

	.notification {
		max-width: var(--theme-layout-max, 990px);
  		width: 100%;
		padding: var(--theme-layout-margin, var(--theme-layout-margin--sm));
	}

	.notification > * {
		background-image: linear-gradient(#cdd23f, #dce14d);
		transition: transform 0.3s;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 25px;
		color: rgb(0 51 73 / var(--tw-text-opacity, 1));
		
	}

	.notification > a:hover {
		transform: scale(1.05);
	}

</style>